/**
 * Created by hao.cheng on 2017/4/28.
 */

import lodash from "lodash"

// 连字符转驼峰
String.prototype.hyphenToHump = function () {
    return this.replace(/-(\w)/g, (...args) => {
        return args[1].toUpperCase()
    })
}

// 驼峰转连字符
String.prototype.humpToHyphen = function () {
    return this.replace(/([A-Z])/g, '-$1').toLowerCase()
}

// 日期格式化
Date.prototype.format = function (format) {
    const o = {
        'M+': this.getMonth() + 1,
        'd+': this.getDate(),
        'h+': this.getHours(),
        'H+': this.getHours(),
        'm+': this.getMinutes(),
        's+': this.getSeconds(),
        'q+': Math.floor((this.getMonth() + 3) / 3),
        S: this.getMilliseconds(),
    }
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, `${this.getFullYear()}`.substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : (`00${o[k]}`).substr(`${o[k]}`.length))
        }
    }
    return format
}

// 获取url的全部参数
export const queryString = () => {
    let _queryString = {};
    const _query = window.location.search.substr(1);
    const _vars = _query.split('&');
    _vars.forEach((v, i) => {
        const _pair = v.split('=');
        if (!_queryString.hasOwnProperty(_pair[0])) {
            _queryString[_pair[0]] = decodeURIComponent(_pair[1]);
        } else if (typeof _queryString[_pair[0]] === 'string') {
            const _arr = [_queryString[_pair[0]], decodeURIComponent(_pair[1])];
            _queryString[_pair[0]] = _arr;
        } else {
            _queryString[_pair[0]].push(decodeURIComponent(_pair[1]));
        }
    });
    return _queryString;
};

//获取url的指定参数
export const queryStringParam = (name) => {
    let reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i')
    let r = window.location.search.substr(1).match(reg)
    if (r != null) return decodeURI(r[2])
    return null
}
//修改url的指定参数
export const replaceStringParam = (paramName, replaceWith) => {
    let oUrl = window.location.href.toString();
    let re = eval('/(' + paramName + '=)([^&]*)/gi');
    let nUrl = oUrl.replace(re, paramName + '=' + replaceWith);
    return nUrl;

}

//去掉值为空的参数
export const removeBlankValParamsStringParam = (params) => {
    var filteredParams = Object.keys(params).reduce(function (r, e) {
        if (params[e]) r[e] = params[e]
        return r;
    }, {})
    return filteredParams
}
//深度copy
export const deepClone = (obj, newObj)=> {
    var newObj = newObj || {};
    for (var key in obj) {
        if (typeof obj[key] == 'object') {
            newObj[key] = (obj[key].constructor === Array) ? [] : {}
            deepClone(obj[key], newObj[key]);
        } else {
            newObj[key] = obj[key]
        }
    }
    return newObj;
}
//tree
export const regroupTowtree = (arrs)=> {
    let arr = lodash.cloneDeep(arrs)
    let newArrs = [];
    for (let key =0; key < arr.length; key++) {
        if (arr[key].children) {
            arr[key].children = regroupTree(arr[key].children);
        } 
        newArrs.push(arr[key])
        
    }
    return newArrs;
}
export const regroupTree = (arr,newArrs=[],parentPro=null)=> {
    for (let key =0; key < arr.length; key++) {
        let _obj = lodash.cloneDeep(arr[key])
        _obj.parentNickname = parentPro;
         delete _obj.children;
        newArrs.push(_obj);
        if (arr[key].children) {
            regroupTree(arr[key].children, newArrs,arr[key].nickname);
        } else {
           
        }
        
        
    }
    return newArrs;
}
//计算树的最大层级
export const countTree = (list,proName)=> {
    for(var a = 0, max = 0; a < list.length; a++) {
      max = Math.max(max, countOne(list[a],proName))
    }
    return max
  }
 function countOne (item,proName, deep) {
    deep = (deep || 0) + 1
    var max = deep;
    if(getType(item) === 'Object' && getType(item[proName]) === 'Array' && item[proName].length) {
      for(var a = 0; a < item[proName].length; a++) {
        max = Math.max(countOne(item[proName][a],proName,deep), max)
      }
    }
    return max
  }
  
function getType (data) {
    return Object.prototype.toString.call(data).replace(/(.*\s)|.$/g, '');
  }

/**
 * 数组格式转树状结构
 * @param   {array}     array
 * @param   {String}    id
 * @param   {String}    pid
 * @param   {String}    children
 * @return  {Array}
 */
export const arrayToTree = (array, id = 'id', pid = 'pid', children = 'children') => {
    let data = lodash.cloneDeep(array)
    let result = []
    let hash = {}
    data.forEach((item, index) => {
        hash[data[index][id]] = data[index]
    })

    data.forEach((item) => {
        let hashVP = hash[item[pid]]
        if (hashVP) {
            !hashVP[children] && (hashVP[children] = [])
            hashVP[children].push(item)
        } else {
            result.push(item)
        }
    })
    return result
}

/**
 * 合并antd table 列( 只合并会变的字段 )
 * @param array1
 * @param array2
 * @param keyField
 * @returns {*}
 */
export const antdTableColumnsMerge = (columns, overrideColumns) => {

    if (!overrideColumns || overrideColumns.length == 0)
        return columns;

    var overrideArrayIndexed = {}
    overrideColumns.forEach((element) => {
        var uniqueKey = ("key" in element) ? "key" : "dataIndex";
        overrideArrayIndexed[element[uniqueKey]] = element;
    })

    return columns.map((element) => {
        var uniqueKey = ("key" in element) ? "key" : "dataIndex";
        if (element[uniqueKey] in overrideArrayIndexed) {
            var overrideElement = overrideArrayIndexed[element[uniqueKey]];
            return Object.assign({}, element, {
                fixed: overrideElement.fixed,
                sorter: overrideElement.sorter,
                hidden: overrideElement.hidden,
            })
        } else {
            return element;
        }
    })
}
//判断是否是微信环境
export const isWeixinBrowser = () => {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        if (ua.match(/wxwork/i) == 'wxwork') {
            return true;
        } else {
            return true;
        }
    }
    return true;
}
//判断是否是企业微信环境
export const isWeixinWorkBrowser = () => {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        if (ua.match(/wxwork/i) == 'wxwork') {
            return true;
        } else {
            return false;
        }
    }
    return false;
}
// 判断是否是手机端浏览器
export const getIsMobileBrowser = () => {
    var ua = navigator.userAgent.toLowerCase();
    var btypeInfo = (ua.match(/firefox|chrome|safari|opera/g) || "other")[0];
    if ((ua.match(/msie|trident/g) || [])[0]) {
        btypeInfo = "msie";
    }
    var pc = "";
    var prefix = "";
    var plat = "";
    //如果没有触摸事件 判定为PC
    var isTocuh = ("ontouchstart" in window) || (ua.indexOf("touch") !== -1) || (ua.indexOf("mobile") !== -1);
    if (isTocuh) {
        if (ua.indexOf("ipad") !== -1) {
            pc = "pad";
        } else if (ua.indexOf("mobile") !== -1) {
            pc = "mobile";
        } else if (ua.indexOf("android") !== -1) {
            pc = "androidPad";
        } else {
            pc = "pc";
        }
    } else {
        pc = "pc";
    }
    switch (btypeInfo) {
        case "chrome":
        case "safari":
        case "mobile":
            prefix = "webkit";
            break;
        case "msie":
            prefix = "ms";
            break;
        case "firefox":
            prefix = "Moz";
            break;
        case "opera":
            prefix = "O";
            break;
        default:
            prefix = "webkit";
            break
    }
    plat = (ua.indexOf("android") > 0) ? "android" : navigator.platform.toLowerCase();
    return {
        version: (ua.match(/[\s\S]+(?:rv|it|ra|ie)[\/: ]([\d.]+)/) || [])[1],     //版本
        plat: plat,                   //系统
        type: btypeInfo,              //浏览器
        pc: pc,
        prefix: prefix,                //前缀
        isMobile: (pc == "pc") ? false : true              //是否是移动端
    };
}








// WEBPACK FOOTER //
// ./src/utils/index.jsx